import ListView, { ListViewItem } from '@ingka/list-view';

import { useSalesPersonDiscounts } from '@/hooks/asset-price-discounts.hooks';

import styles from '../../styles.module.scss';

export const DiscountSummaryOverview = () => {
    const { discountListItems } = useSalesPersonDiscounts();

    return (
        <>
            <hr className={styles.divider} />

            <ListView id="discount-items" size="medium" showDivider={true}>
                {discountListItems.map((itemProps) => (
                    <ListViewItem
                        key={itemProps.title}
                        description={itemProps.description}
                        title={itemProps.title}
                        quantityLabel={itemProps.quantityLabel}
                    />
                ))}
            </ListView>
        </>
    );
};
